import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BooleanInput } from '@shared/decorators/boolean-input.decorator';
import { AccountPublicApiService } from '@/app/platform/platform-core/user/services/account-public-api.service';

@Component({
    selector: 'login-factory',
    templateUrl: './login-factory.component.html',
    styleUrls: ['./login-factory.component.scss'],
    host: {
        class: 'p-3'
    },
    standalone: false
})
export class LoginFactoryComponent implements OnInit {
  @BooleanInput() @Input() showCredentialLogin: boolean;
  @Output() afterLogin = new EventEmitter<never>();

  constructor(private readonly accountApi: AccountPublicApiService) {}

  email = '';

  registrationEnabled = false;
  hasUsableRegistrationKeys = false;

  ngOnInit(): void {
    this.loadRegistrationConfig();
  }

  private async loadRegistrationConfig(): Promise<void> {
    const result = await this.accountApi.getRegistrationConfig();
    result.ifSuccess(config => {
      this.registrationEnabled = config.registrationEnabled;
      this.hasUsableRegistrationKeys = config.hasUsableRegistrationKeys;
    });
  }
}
